export const environment = {
  production: true,
  appVersion: 'V2.1',
  USERDATA_KEY: 'authf916cf5a5f65',
  swFilePath: '/thynk',
  isMockEnabled: false,
  apiUrl: 'https://stage-thynk-api.santechture.com/services',
  adminAPIUrl: 'https://stage-thynk-api.santechture.com/admin',

  apiUrlForAdmin: 'https://stage-thynk-api.santechture.com',

  apiUrlIntegration: 'https://stage-thynk-api.santechture.com/integ',
  apiUrlRules: 'https://stage-thynk-api.santechture.com/thynk-rule-files',

  // pdfUrl:
  //   'https://stage-api.santechture.com/codemap/services/account/download-transaction',
  uploadUrl: 'https://stage-files.santechture.com',
  clientUrl: 'https://stage-www.santechture.com/client',
  backendBaseImageUrl: 'https://stg-files.santechture.com',

};
